<!-- "New Network" dialog -->
<p-dialog modal="true" appendTo="body" [(visible)]="display" (onHide)="onDialogHide()" [resizable]="false">

	<p-header>
		<span>Enter a name for your new network</span>
	</p-header>

	<div>
		<label for="name">Name</label><br />
		<input name="name" type="text" style="width: 100%;" pInputText [(ngModel)]="newItemName" />
	</div>

	<div>
		<label for="description">Description</label><br />
		<input name="description" type="text" style="width: 100%;" pInputText [(ngModel)]="newItemDesc" />
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="hideDialog(); addNewNetwork()" label="OK"></button>
		<button type="button" pButton icon="fa fa-close" (click)="hideDialog()" label="Cancel"></button>
	</p-footer>

</p-dialog>
